(ns livefeed.api
  (:require [cljs.core.async :refer-macros [go] :refer [<!]]
            [cljs-http.client :as http]
            [livefeed.properties :as properties]
            [livefeed.util :refer [->kebab-case-keys]]
            [livefeed.message-status :as status]))

(defn backend-url []
  (properties/get-property :backend-api-url))

(defn chat-public-url []
  (properties/get-property :chat-public-url))

(defn- default-error-handler [status body]
  (case status
    404 ::not-found
    (do
      (status/connection-error!)
      (js/console.error (str "Error during http request. Status: " status ", body: " body))
      nil)))

(defn- nil-error-handler [_ _] nil)

(defn- http-method-post [url body]
  (http/post url {:timeout      5000
                  :query-params {:app_id  (properties/get-property :appId)
                                 :app_key (properties/get-property :appKey)}
                  :headers      {"Content-Type" "application/json"}
                  :body         body}))

(defn- http-method-get [url _]
  (http/get url {:timeout      5000
                 :query-params {:app_id  (properties/get-property :appId)
                                :app_key (properties/get-property :appKey)}}))

(defn- http-request [method url body error-handler]
  (go (let [{:keys [status body]} (<! (method url body))]
        (case status
          200 (->kebab-case-keys body)
          (error-handler status body)))))

(defn http-post
  ([url body]
   (http-post url body default-error-handler))
  ([url body error-handler]
   (http-request http-method-post url body error-handler)))

(defn http-get
  ([url]
   (http-get url default-error-handler))
  ([url error-handler]
   (http-request http-method-get url nil error-handler)))

(defn get-labeled-messages [chat-id label]
  (http-get (str (backend-url)
                 "/v1/chats/"
                 chat-id
                 "/comments/label/"
                 label
                 "/latest")))

(defn get-chat [chat-id]
  (http-get (str (backend-url) "/v1/chats/" chat-id "/metadata")))

(defn get-chat-by-path [path]
  (http-get (str (backend-url) "/v1/chats/path/" path)))

(defn get-initial-messages [chat-id best?]
  (go (reverse (<! (http-get (str (backend-url) "/v1/chats/" chat-id "/comments" (when best? "/best") "/latest"))))))

(defn get-messages-before [chat-id timestamp best?]
  (go (reverse (<! (http-get (str (backend-url) "/v1/chats/" chat-id "/comments" (when best? "/best") "/before/" timestamp))))))

(defn get-messages-after [chat-id timestamp best?]
  (http-get (str (backend-url) "/v1/chats/" chat-id "/comments" (when best? "/best") "/after/" timestamp)))

(defn get-poll-results [poll-id]
  (http-get (str (backend-url) "/v1/poll/" poll-id "/status") nil-error-handler))

(defn post-report [report]
  (http-post
   (str (backend-url) "/v1/report")
   (js/JSON.stringify (clj->js report))
   (fn [status body]
     (case status
       400 (if (= body "Cannot create notice for unaccepted comment")
             :error-message-rejected
             false)
       false))))
